<template>
    <div>
        <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" class="pa-1">
                <v-select v-model="dNivel" label="* Niveles"
                    :items="dNivels"
                    :disabled="dLoading" solo></v-select>
            </v-col>
            <v-col cols="12" sm="8" md="8" lg="8" class="pa-1">
                <v-autocomplete
                    v-model="dIdSeccion"
                    :items="dMatSeccionesList"
                    solo
                    chips
                    color="blue-grey lighten-2"
                    label="* Sección"
                    item-text="name"
                    item-value="id"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            @click="data.select">
                            <v-avatar>
                                <v-icon>{{ fuTurnoIcono(data.item.avatar) }}</v-icon>
                            </v-avatar>
                            <strong>{{ " " + data.item.name }}</strong> 
                            <span> {{ " " + data.item.group + " " + fuMesNombreFecha(parseInt(data.item.FechaInicio.substring(5,7)))+" "+parseInt(data.item.FechaInicio.substring(8,10))}}</span>
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template>
                            <v-list-item-avatar>
                                <v-icon large>{{ fuTurnoIcono(data.item.avatar) }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <strong :title="data.item.id">{{ data.item.name }}</strong> {{ data.item.group }}
                                </v-list-item-title>
                                <v-list-item-subtitle>{{fuMesNombreFecha(parseInt(data.item.FechaInicio.substring(5,7)))+" "+parseInt(data.item.FechaInicio.substring(8,10))}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" class="pa-0">
                <v-list flat class="pa-0">
                    <v-list-item v-for="item in dMatCursoMinisterios" :key="item.IdCursoMinisterio">
                        <v-list-item-action>
                            <v-checkbox color="orange"
                                v-model="dMatCursoMinisterioSelected" 
                                :value="item.IdCursoCurricula"
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content class="pa-1">
                            <v-alert color="warning" text label dense border="left">
                                {{ item.Descripcion }}
                            </v-alert>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="12" sm="12" class="grey lighten-2">
                <v-btn @click.prevent="fuSave()" :disabled="dMatCursoMinisterioSelected.length==0" color="warning"><v-icon>save</v-icon> Guardar</v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { fuTurnoIcono, fuMesNombreFecha} from '@/helpers/index.js';

export default {
    name: 'MatriculaByAlumno',
    props: {
        pIdAlumno: {
            type: Number,
            required: true,
        },
    },
    mounted(){
        if (this.pIdAlumno)
            this.fumatcursosministerioEgresadoDetalle(this.pIdAlumno);
    },
    data: () => ({
        dLoading : false,
        dMatCursosMinisterioEgresadoDetalle: [],
        dNivel: null,
        dNivels: [],
        dIdSeccion: null,
        dMatSecciones: [],
        dMatSeccionesList: [],
        dMatCursoMinisterios: [],
        dMatCursoMinisterioSelected: [],
        dMatCursoMinisterioValid: [],
    }),
    watch: {
        pIdAlumno(val){
            if(val){
                this.fumatcursosministerioEgresadoDetalle(parseInt(val));
            }
        },
        dNivel(val){
            if(val){
                this.dMatCursoMinisterios = [];
                this.dMatCursoMinisterioSelected = [];
                this.matseccionAMatricularByNivel(val);
            }
        },
        dIdSeccion(val){
            if(val){
                this.dMatCursoMinisterios = [];
                this.dMatCursoMinisterioSelected = [];
                let CCURSOCURRICULA;

                const CCURSOMINISTERIO = this.dMatCursosMinisterioEgresadoDetalle
                                .filter(x => (x.Nivel==this.dNivel && !x.IdCursoCurricula ))
                                .map(obj => ({
                                    IdCursoMinisterio: obj.IdCursoMinisterio,
                                    Descripcion: obj.Descripcion,
                                }));
                const seccionSeleccionada = this.dMatSecciones.find(x => x.IdSeccion === val);
                if (seccionSeleccionada) {
                    CCURSOCURRICULA = seccionSeleccionada.matcursoscurricula.flatMap(curso => 
                        curso.matcursosequivalente.map(equiv => ({
                            IdCursoCurricula: equiv.IdCursoCurricula,
                            IdCursoMinisterio: equiv.IdCursoMinisterio,
                        }))
                    );
                }
                const curriculaMap = new Map(
                    CCURSOCURRICULA.map(item => [item.IdCursoMinisterio.toString(), item.IdCursoCurricula])
                );

                this.dMatCursoMinisterios = CCURSOMINISTERIO
                    .filter(curso => curriculaMap.has(curso.IdCursoMinisterio.toString()))
                    .map(curso => ({
                        ...curso,
                        IdCursoCurricula: curriculaMap.get(curso.IdCursoMinisterio.toString())
                    }));
                console.log(this.dMatCursoMinisterios);
            }
        },
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuTurnoIcono, fuMesNombreFecha,
        async fumatcursosministerioEgresadoDetalle(p_IdAlumno) {
            this.dMatCursosMinisterioEgresadoDetalle = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdAlumno: ID!){
                            matcursosministerioEgresadoDetalle(IdAlumno: $IdAlumno){
                                IdCursoMinisterio
                                Descripcion
                                Nivel
                                Creditos
                                IdMatricula
                                IdSeccion
                                CondicionMat
                                IdCursoCurricula
                                NotaFinal
                                EstadoAcademico
                                Periodo
                                Seccion
                                Turno
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno
                    }
                })                
                const arrayIdCursoCurriculaNotNull = response.data.matcursosministerioEgresadoDetalle.filter(x=>x.IdCursoCurricula!=null);
                const arrayUniqueNivel = [...new Set(arrayIdCursoCurriculaNotNull.map(x => (x.Nivel)))];
                this.dMatCursosMinisterioEgresadoDetalle = response.data.matcursosministerioEgresadoDetalle.filter(x=>arrayUniqueNivel.includes(x.Nivel));

                const arrayIdCursoCurriculaNull = this.dMatCursosMinisterioEgresadoDetalle.filter(x=>x.IdCursoCurricula==null);
                this.dNivels = [...new Set(arrayIdCursoCurriculaNull.map(x => (x.Nivel)))];
                
                // this.dMatCursosMinisterioEgresadoDetalle = this.dMatCursosMinisterioEgresadoDetalle.sort((p1, p2) => (p1.Nivel < p2.Nivel) ? 1 : (p1.Nivel > p2.Nivel) ? -1 : 0);
            } catch (error) {
                console.log(error);
            }
        },
        async matseccionAMatricularByNivel(p_Nivel){
            try {
                this.dIdSeccion = null,
                this.dMatSecciones = [];
                this.dMatSeccionesList = [];
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!, $Nivel: Int!){
                            matseccionAMatricularByNivel(IdAlumno: $IdAlumno, Nivel: $Nivel){
                                IdSeccion
                                Seccion
                                Turno
                                FechaInicio
                                FechaFin
                                matperiodo{
                                    Anio
                                    Periodo
                                    Nivel
                                }
                                matcursoscurricula{
                                    matcursosequivalente{
                                        IdCursoCurricula
                                        IdCursoMinisterio
                                    }
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        Nivel: p_Nivel
                    }
                })
                this.dMatSecciones = response.data.matseccionAMatricularByNivel;
                this.dMatSeccionesList = response.data.matseccionAMatricularByNivel
                    .map(obj => ({
                        id: obj.IdSeccion,
                        name: obj.matperiodo.Nivel + obj.Seccion,
                        group: obj.matperiodo.Anio + '-' + obj.matperiodo.Periodo,
                        avatar: obj.Turno,
                        FechaInicio: obj.FechaInicio,
                    }));
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                console.log(error);
            } finally {
            }
        },
        fuSave(){
            Swal.fire({
                icon: 'question',
                title: '¿Estás seguro?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, matricular',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    this.fuMatriculaCreate();
                },
            }).then(() => {
            });
        },
        async fuMatriculaCreate () {
            try {
                this.dLoading = true;
                const vIdCursoCurriculas = this.dMatCursoMinisterioSelected.join(',');

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation matmatriculaSpMATRICULAS(
                        $IdSeccion: String,
                        $IdAlumno: String,
                        $FechaMatricula: String,
                        $IdCurricula: String,
                        $Observacion: String,
                        $Grupo: String,
                        $Condicion: String,
                        $CondicionMat: String,
                        $Operador: String,
                        $Accion: String,
                        $IdCursoCurriculas: String,
                    ){
                        matmatriculaSpMATRICULAS(
                            IdSeccion: $IdSeccion,
                            IdAlumno: $IdAlumno,
                            FechaMatricula: $FechaMatricula,
                            IdCurricula: $IdCurricula,
                            Observacion: $Observacion,
                            Grupo: $Grupo,
                            Condicion: $Condicion,
                            CondicionMat: $CondicionMat,
                            Operador: $Operador,
                            Accion: $Accion,
                            IdCursoCurriculas: $IdCursoCurriculas
                        ){
                            success
                            message
                        }
                    }`,
                    variables: {
                        IdSeccion : this.dIdSeccion,
                        IdAlumno : this.pIdAlumno,
                        FechaMatricula : moment().format("YYYYMMDD HH:mm:ss"),
                        IdCurricula : "0",
                        Observacion : "",
                        Grupo : "1",
                        Condicion : "REGULAR",
                        CondicionMat : "POR CURSO",
                        Operador : this.ssUser.Usuario,
                        Accion : 'C1',
                        IdCursoCurriculas: vIdCursoCurriculas
                    }
                });
                if(response.data.matmatriculaSpMATRICULAS.success==1){
                    Swal.fire('¡ CORRECTO !', 'Matricula correcta', 'success');
                    this.$emit('fuMatriculaList');
                } else {
                    Swal.fire('¡ ERROR !', response.data.matmatriculaSpMATRICULAS.message, 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó la matricula.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
